import React, { memo } from "react";
import styles from "./ProviderDashboardCards.module.scss";
import { ProviderDashboardData } from "../../../../../model/provider/provider-dashboard-data";

type Props = {
	dashboardData?: ProviderDashboardData;
};

const ProviderDashboardCards: React.FC<Props> = memo((props: Props) => {
	return (
		<div className={styles.cardsContainer}>
			<div className={`${styles.card} ${styles.numberOfActiveSolarProductsCard}`}>
				<div className={styles.cardHeader}>Total number of solar products</div>
				<div className={styles.cardBody}>
					<div className={`${styles.pill} ${styles.greenPill}`}>Active</div>
					<div className={styles.cardBodyContent}>{props.dashboardData?.totalNumberOfActiveSolarProducts ?? 0}</div>
				</div>
			</div>
			<div className={`${styles.card} ${styles.numberOfInactiveSolarProductsCard}`}>
				<div className={styles.cardHeader}>Total number of solar products</div>
				<div className={styles.cardBody}>
					<div className={`${styles.pill} ${styles.redPill}`}>Inactive</div>
					<div className={styles.cardBodyContent}>{props.dashboardData?.totalNumberOfInactiveSolarProducts ?? 0}</div>
				</div>
			</div>
			<div className={`${styles.card} ${styles.numberOfTotalSalesRequestsCard}`}>
				<div className={styles.cardHeader}>Total number of sales requests</div>
				<div className={styles.cardBody}>
					<div className={styles.cardBodyContent}>{props.dashboardData?.totalNumberOfSaleRequests ?? 0}</div>
				</div>
			</div>
			<div className={`${styles.card} ${styles.numberOfInstalationsCard}`}>
				<div className={styles.cardHeader}>Total number of installations</div>
				<div className={styles.cardBody}>
					<div className={styles.cardBodyContent}>{props.dashboardData?.totalNumberOfInstalations ?? 0}</div>
				</div>
			</div>
			<div className={`${styles.card} ${styles.accountBalanceCard}`}>
				<div className={styles.cardHeader}>Account Balance</div>
				<div className={styles.cardBody}>
					<div className={styles.cardBodyContent}>{props.dashboardData?.accountBalance ?? 0}</div>
				</div>
			</div>
		</div>
	);
});

export default ProviderDashboardCards;
